export default __webpack_public_path__ + "static/media/mussen-nest-logo-dark.64e2180b.svg";